import React from 'react'

function Home() {
    return (<>
    <h1 className='pageTitle'>Pickalator</h1>
    <p className='pageBody'>Welcome to the pickalator app.</p>
    </>)
}

export default Home;